module.exports = __webpack_public_path__ + "static/media/jiantou_icon_sec.563112bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/jiantou_icon_sec.png
// module id = 392
// module chunks = 0 1